<script lang="ts">
  import type { AnalysisDataMode } from '../lib/types';

  export let dataMode: AnalysisDataMode;
  export let selectedPlotCount: number;
  export let maximumSelectedPlots: number;
  export let onChooseDataMode: (mode: AnalysisDataMode) => void;
</script>

<header class="analysis-panel__header">
  <div class="analysis-panel__heading">
    <h2 id="analysis-heading">Analysis</h2>
    <span id="analysis-data-mode-label" class="analysis-panel__mode-label">Analysis mode</span>
    <div class="segmented" role="group" aria-labelledby="analysis-data-mode-label">
      <button class:active={dataMode === 'plot-data'} aria-pressed={dataMode === 'plot-data'} type="button" on:click={() => onChooseDataMode('plot-data')}>Plot data</button>
      <button class:active={dataMode === 'event-waveforms'} aria-pressed={dataMode === 'event-waveforms'} type="button" on:click={() => onChooseDataMode('event-waveforms')}>Event waveforms</button>
    </div>
    <p>Compare plotted series and calculate statistics from the samples currently shown.</p>
  </div>
  <span class="analysis-panel__count">{selectedPlotCount}/{maximumSelectedPlots} plots selected</span>
</header>
